import React, { useContext } from 'react'

// Context
import { OverlayContext } from '../../../../contexts'

// Components
import { Show, If } from '../../../../components'
import DisclaimerPanel from '../DisclaimerPanel'
import MonthlyCostPanel from '../MonthlyCostPanel'
import ComparedToRenting from '../ComparedToRenting'
import ComparedToStaying from '../ComparedToStaying'

// Constants
import { PANEL_IDS } from '../../../../constants/overlayPanels'

const OverlayPanels = () => {
  const { activeOverlayId, handleOverlayBack } = useContext(OverlayContext)

  return (
    <>
      <Show condition={activeOverlayId === PANEL_IDS.DISCLAIMER}>
        <DisclaimerPanel handleBack={handleOverlayBack} />
      </Show>
      <Show condition={activeOverlayId === PANEL_IDS.MONTHLY_COST}>
        <MonthlyCostPanel handleBack={handleOverlayBack} />
      </Show>
      <Show condition={activeOverlayId === PANEL_IDS.BREAKEVEN_CHART}>
        <If.Own>
          <ComparedToStaying handleBack={handleOverlayBack} />
        </If.Own>
        <If.Rent>
          <ComparedToRenting handleBack={handleOverlayBack} />
        </If.Rent>
      </Show>
    </>
  )
}

export default OverlayPanels
